// extracted by mini-css-extract-plugin
export default {"container":"AccordionSummary_container__43pV0","icon":"AccordionSummary_icon__K04f+"};